export default "__VITE_ASSET__BCPsE2eX__"